import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MessageService, ConfirmationService, Message } from "primeng/api";

import { UsuarioService } from '../usuario.service';
import { PessoaCombo, Usuario, UsuarioFornecedor } from '../models/usuario';
import { Perfil } from '../models/perfil';
import { ComissaoService } from '../../comissao/comissao.service';
import { TipoComissao } from '../../comissao/models/comissao';
import HitDragging from '@fullcalendar/interaction/interactions/HitDragging';
import { FornecedorService } from '../../fornecedor/fornecedor.service';
import { Fornecedor } from '../../fornecedor/models/fornecedor';
import { Pessoa } from '../../pessoa/models/pessoa';
import { PessoaService } from '../../pessoa/pessoa.service';

@Component({
  selector: 'cria-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class UsuarioListComponent implements OnInit {

  public usuarios: Usuario[];
  public listaPerfil: Perfil[];
  public selectedPerfil: Perfil[] = [];

  public listaTipoComissao: TipoComissao[];
  public selectedTipoComissao: TipoComissao;

  public listaPessoa: PessoaCombo[];
  public selectedPessoa: PessoaCombo;

  public listaFornecedor: Fornecedor[] = [];
  public selectedFornecedores: Fornecedor[] = [];

  public flVendedor: boolean;
  public displayMsg: boolean = false;
  public idUsuario: string;

  public usuarioDialog: boolean;
  public fornecedorDialog: boolean;
  public usuario: Usuario;
  public selectedUsuarios: Usuario[];
  public submitted: boolean;



  constructor(public usuarioService: UsuarioService,
              private comissaoService: ComissaoService,
              private fornecedorService: FornecedorService,
              private pessoaService: PessoaService,
              private router: Router,
              private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.flVendedor = false;
    this.getUsuarios();
  }

  getUsuarios() {
    this.usuarioService.getUsuarios().subscribe(
      (res) => {
        if (res) {
          this.usuarios = res;
          this.selectedPerfil = [];
          this.getPerfil();
          this.getTiposComissao();
          this.getFornecedores();          
        }
      },
      err => {
        console.log("UsuarioList - Usuário");
        console.log(err);
      }
    );
  }

  getPerfil() {
    this.usuarioService.getPerfil().subscribe(
      (res) => {
        if (res) {
          this.listaPerfil = res;
        }
      },
      err => {
        console.log("UsuarioList - Perfil");
        console.log(err);
      }
    );
  }

  filterPessoa(event) {
    let query = event.query;
    this.pessoaService.getPessoaComboLista(query).subscribe(
      (res) => {
        if (res) {
          this.listaPessoa = res;
          console.log(res);
        }
      },
      err => {
        console.log("UsuarioList - Pessoa");
        console.log(err);
      }
    );
  }

  getTiposComissao() {
    this.comissaoService.getTiposComissao().subscribe(
      (res) => {
        if (res) {
          this.listaTipoComissao = res;
        }
      },
      err => {
        console.log("UsuarioList - TiposComissao");
        console.log(err);
      }
    );
  }

  getSelectedPerfil(idUsuario: number) {
    this.usuarioService.getSelectedPerfil(idUsuario).subscribe(
      (res) => {
        if (res) {
          this.selectedPerfil = res;
        }
      },
      err => {
        console.log("UsuarioList - SelectedPerfil");
        console.log(err);
      }
    );
  }

  getSelectedPessoa() {    
    
    this.selectedPessoa = {};

    if (this.usuario === undefined || this.usuario.idPessoa === null) {
      this.selectedPessoa = {};
    }
    else
    {
      this.pessoaService.getPessoaCombo(this.usuario.idPessoa).subscribe(
        (res) => {
          this.selectedPessoa = res;            
          console.log(this.selectedPessoa);          
        },
        err => {
          console.log("UsuarioList - Pessoa");
          console.log(err);
        }
      );
    }    
  }

  getSelectedTipoComissao(idTipoComissao: number) {
    return this.listaTipoComissao.find(x => x.idComissaoTipo == idTipoComissao);
  }

  getFornecedores() {
    this.fornecedorService.getFornecedores().subscribe(
      (res) => {
        if (res) {
          this.listaFornecedor = res;
        }
      },
      err => {
        console.log("UsuarioList - Fornecedores");
        console.log(err);
      }
    );
  }

  getFornecedorChecked(idUsuario: number) {
    this.usuarioService.getFornecedorChecked(idUsuario).subscribe(
      (res) => {
        if (res) {
          this.selectedFornecedores = res;
        }
      },
      err => {
        console.log("UsuarioList - FornecedoresChecked");
        console.log(err);
      }
    );
  }

  editFoto(usuario: Usuario) {
    console.log("goto");
  }

  openNew() {
    this.usuario = {};
    this.selectedPessoa = {};
    this.selectedPerfil = [];
    this.selectedFornecedores = [];
    this.selectedTipoComissao = {};
    this.submitted = false;
    this.usuarioDialog = true;
  }

  editUsuario(usuario: Usuario) {
    this.getSelectedPerfil(usuario.idUsuario);
    this.getFornecedorChecked(usuario.idUsuario);    
    this.selectedTipoComissao = this.getSelectedTipoComissao(usuario.idComissaoTipo);
    this.usuario = { ...usuario };
    this.getSelectedPessoa();
    this.usuarioDialog = true;
  }

  deleteUsuario(usuario: Usuario) {
    this.confirmationService.confirm({
      message: 'Você tem certeza que deseja remover o usuário: ' + usuario.login + '?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.usuarioService
          .delUsuarios(usuario)
          .subscribe(
            () => this.getUsuarios(),
            err => console.log(err)
          );
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Usuário removido com sucesso!', life: 3000 });
      }
    });
  }

  resetSenha(usuario: Usuario) {
    this.confirmationService.confirm({
      message: 'Você tem certeza que deseja resetar a senha do usuário: ' + usuario.login + '?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.usuarioService
          .resetSenha(usuario)
          .subscribe(
            () => this.getUsuarios(),
            err => console.log(err)
          );
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Senha resetado com sucesso!', life: 3000 });
      }
    });
  }

  hideDialog() {
    this.usuarioDialog = false;
    this.submitted = false;
    this.selectedPerfil = [];
  }

  hideFornecedorDialog() {
    this.fornecedorDialog = false;
    this.submitted = false;
  }

  saveUsuario() {
    this.submitted = true;
    this.usuario.idPessoa = this.selectedPessoa.id;
    let id = this.usuario.idUsuario;    
    if (this.usuario.login.trim()) {
      if (this.usuario.idUsuario) {
        this.usuarioService
          .updUsuarios(this.usuario)
          .subscribe(
            () => {              
              this.saveUsuarioPerfil(id);
            },
            err => console.log(err)
          );
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Usuário atualizado com sucesso!', life: 3000 });
      } else {
        this.usuarioService
          .addUsuarios(this.usuario)
          .subscribe(
            (response) => {   
              console.log(response);
              this.saveUsuarioPerfil(Number(response));
            },
            err => console.log(err)
          );

        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Usuário cadastrado com sucesso!', life: 3000 });
      }

      this.usuarios = [...this.usuarios];
      this.usuarioDialog = false;
      this.usuario = {};
    }
  }

  saveUsuarioFornecedor(idUsuario: number) {
    this.submitted = true;
    console.log(this.selectedFornecedores);
    if (this.selectedFornecedores) {
      this.usuarioService
        .updUsuarioFornecedor(this.selectedFornecedores, idUsuario)
        .subscribe(
          () => {
            this.getUsuarios();
          },
          err => console.log(err)
        );
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Perfis de acesso atualizados com sucesso!', life: 3000 });
    }

    this.hideFornecedorDialog();
  }

  saveUsuarioPerfil(idUsuario: number) {
    this.submitted = true;
    if (this.selectedPerfil) {
      this.usuarioService
        .updUsuarioPerfil(this.selectedPerfil, idUsuario)
        .subscribe(
          () => {
            this.saveUsuarioFornecedor(idUsuario);            
          },
          err => console.log(err)
        );
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Perfis de acesso atualizados com sucesso!', life: 3000 });
    }

    this.hideFornecedorDialog();
  }


  // SetPerfil(perfil: Perfil)
  // {
  //   this.usuario.idPerfil = perfil.idPerfil;   
  //   this.flVendedor = (perfil.cdPerfil == "VENDEDOR" ? true : false);    
  // }

  SetComissaoTipo() {
    this.usuario.idComissaoTipo = this.selectedTipoComissao.idComissaoTipo;
  }
}

